import './components/diseñocss/App.css';
import { Routes, Route, Navigate } from "react-router-dom"
import ProtectedRoute from './ProtectedRoute';
import React from 'react';
import Seleccion from './components/paginas_platos/Seleccion';
import CargaDiaria from './components/paginas_platos/CargaDiaria';
import CargaMenuSemanal from './components/paginas_platos/CargaMenuSemanal';
import AbmPlatos from './components/paginas_platos/AbmPlatos';
import AbmPedidos from './components/paginas_platos/AbmPedidos';
import ConfiguracionSemanal from './components/paginas_platos/ConfiguracionSemanal';
import CrearPlatos from './components/paginas_platos/CrearPlatos';
import EditarPlatos from './components/paginas_platos/EditarPlatos';
import AbmTiposMenu from './components/paginas_platos/AbmTiposMenu';
import CreateUser from './components/paginas_usuarios/CreateUser';
import EditUser from './components/paginas_usuarios/EditUser';
import AbmUsuarios from './components/paginas_usuarios/AbmUsuarios';
import Login from './components/paginas_usuarios/Login';


//Importacion de barras de usuarios según el tipo de usuario
import Sidebar from './components/barradeNavegacion/Sidebar';
import Footer from './components/footer/Footer.jsx'
import '../src/components/diseñocss/App.css'

//Importacion de tocken para la autenticacion del usuario
import { AuthProvider, useAuth } from './components/guardarToken/authContext';
import { ThemeProvider, useTheme } from './components/guardarToken/themeContext';
import AbmDirecciones from './components/paginas_usuarios/AbmDirecciones.jsx';
import CreateAddres from './components/paginas_usuarios/CreateDirecciones.jsx';
import EditAddres from './components/paginas_usuarios/EditAddres.jsx';
import AbmSectores from './components/paginas_usuarios/AbmSectores.jsx';
import CreateSection from './components/paginas_usuarios/CreateSector.jsx';
import EditSection from './components/paginas_usuarios/EditSector.jsx';
import AbmSedes from './components/paginas_usuarios/AbmSedes.jsx';
import CreateSede from './components/paginas_usuarios/CreateSede.jsx';
import EditSede from './components/paginas_usuarios/EditSede.jsx';

import Dashpage from './components/Dashboard/Dashpage.jsx';
import VistaPedidosComparativo from './components/paginas_platos/VistaPedidosComparativo.jsx';






function App() {


  return (



    <AuthProvider>
      <ThemeProvider>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/*" element={
              <ProtectedRoute>
                <AdminRoutes />
              </ProtectedRoute>
            } />
            <Route path="/user/*" element={
              <ProtectedRoute>
                <UserRoutes />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </ThemeProvider>
    </AuthProvider>

  );
}
function Home() {
  const { authToken, tipoUsuario } = useAuth();

  if (!authToken) {
    return <Login />;
  }

  if (tipoUsuario === 'admin') {
    return <Navigate to="/admin/dashpage" />;
  } else {
    return <Navigate to="/user/mipedidosemanal" />;
  }
}

function AdminRoutes() {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <Sidebar />
      <main className="lg:ml-56 flex flex-col min-h-screen overflow-x-hidden">
        <div className="flex-1 p-4 sm:p-6 pt-16 lg:pt-6">
          <Routes>
            <Route path="dashpage" element={<Dashpage />} />
            <Route path="mipedidosemanal" element={<VistaPedidosComparativo />} />
            <Route path="seleccion" element={<Seleccion />} />
            <Route path="cargadiaria" element={<CargaDiaria />} />
            <Route path="CargarMenuSemanal" element={<CargaMenuSemanal />} />
            <Route path="configuracion-semanal" element={<ConfiguracionSemanal />} />
            <Route path="AbmUsuarios" element={<AbmUsuarios />} />
            <Route path="AbmDirecciones" element={<AbmDirecciones />} />
            <Route path="AbmSectores" element={<AbmSectores />} />
            <Route path="AbmPlatos" element={<AbmPlatos />} />
            <Route path="AbmTiposMenu" element={<AbmTiposMenu />} />
            <Route path="AbmPedidos" element={<AbmPedidos />} />
            <Route path="CreateAddres" element={<CreateAddres />} />
            <Route path="CreatePlatos" element={<CrearPlatos />} />
            <Route path="CreateUser" element={<CreateUser />} />
            <Route path="CreateSection" element={<CreateSection />} />
            <Route path="EditAddres/:id_direccion" element={<EditAddres />} />
            <Route path="EditSection/:id_sector" element={<EditSection />} />
            <Route path="EditarPlatos/:id_plato" element={<EditarPlatos />} />
            <Route path="EditUser/:id" element={<EditUser />} />
            <Route path="AbmSedes" element={<AbmSedes />} />
            <Route path="CreateSede" element={<CreateSede />} />
            <Route path="EditSede/:id" element={<EditSede />} />

          </Routes>
        </div>
        <Footer />
      </main>
    </div>
  );
}

function UserRoutes() {
  const { isDarkMode } = useTheme();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <Sidebar />
      <main className="lg:ml-56 flex flex-col min-h-screen overflow-x-hidden">
        <div className="flex-1 p-4 sm:p-6 pt-16 lg:pt-6">
          <Routes>
            <Route path="mipedidosemanal" element={<VistaPedidosComparativo />} />
            <Route path="seleccion" element={<Seleccion />} />
          </Routes>
        </div>
        <Footer />
      </main>
    </div>
  );
}



export default App;
